import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ConfigProvider from '../config-provider';
import { TransitionGroup } from 'react-transition-group';
import ToastItem from './toast-item.component';
import { func } from '../util';

class ToastContainer extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    toasts: PropTypes.array,
    placement: PropTypes.string,
    tmpl: PropTypes.any,
    onClose: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    prefix: 'next-',
    placement: 'bottomLeft',
    tmpl: ToastItem,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.tmpl !== state.tmpl) {
      return { tmpl: props.tmpl };
    }
    return null;
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      tmpl: props.tmpl,
    };
  }

  findToast = key => {
    const { toasts } = this.props;
    if (!Array.isArray(toasts)) {
      return null;
    }
    const toastIds = toasts.map(toast => toast.key);
    const index = toastIds.indexOf(key);
    return index > -1 ? toasts[index] : null;
  };

  handleClose = key => {
    const toast = this.findToast(key);
    if (toast) {
      const { clearTimeout, onClose } = toast;
      clearTimeout();
      if (func.isFunction(onClose)) {
        onClose(key);
      }
    }
    this.handleRemove(key);
  };

  handlePause = key => {
    const toast = this.findToast(key);
    if (toast) {
      const { clearTimeout, onPause } = toast;
      clearTimeout();
      if (func.isFunction(onPause)) {
        onPause(key);
      }
    }
  };

  handleRemove = key => {
    this.props.onClose(key);
  };

  handleStart = key => {
    const toast = this.findToast(key);
    if (toast) {
      const { startTimeout, onStart } = toast;
      startTimeout();
      if (func.isFunction(onStart)) {
        onStart(key);
      }
    }
  };

  renderToast = (componentProps, toastPrefix) => {
    const {
      clearTimeout,
      className,
      key,
      startTimeout,
      onClose,
      onPause,
      onStart,
      ...restProps
    } = componentProps;

    const cls = cx({
      [`${toastPrefix}-container-child`]: true,
      [className]: !!className,
      [`${toastPrefix}-item`]: true,
    });

    let childProps = {
      ...restProps,
      className: cls,
      key,
      onRemove: this.handleRemove.bind(this, key),
    };

    if (componentProps.closeable) {
      childProps = {
        ...childProps,
        onClose: this.handleClose.bind(this, key),
      };
    }

    if (componentProps.pauseable) {
      childProps = {
        ...childProps,
        onStart: this.handleStart.bind(this, key),
        onPause: this.handlePause.bind(this, key),
      };
    }

    const Tmpl = this.state.tmpl;
    return <Tmpl {...childProps} />;
  };

  replaceTemplate(tmpl) {
    this.setState({
      tmpl,
    });
  }

  render() {
    const { prefix, toasts, className, placement } = this.props;
    const toastPrefix = `${prefix}toast`;

    const cls = cx({
      [`${toastPrefix}-container`]: true,
      [`${toastPrefix}-container-${placement}`]: true,
      [className]: !!className,
    });

    const toastGroup = toasts.map(toast => {
      return this.renderToast(toast, toastPrefix);
    });

    return (
      <TransitionGroup component="div" className={cls}>
        {toastGroup}
      </TransitionGroup>
    );
  }
}

export default ConfigProvider.config(ToastContainer);
